import Alpine from "alpinejs";

Alpine.data('ScrollingBanner', (contentCount) => ({
    speed: 300,
    hoverSpeed: 0,
    content: null,
    lastTime: null,
    x: 0,
    offset: 0,
    eventListeners: {},
    contentCount: null,
    init() {
        this.content = this.$refs.content;
        this.contentCount = contentCount
        this.lastTime = Date.now();

        this.setup();
        this.resize();
        this.bindEvents();
        this.render();

    },
    
    bindEvents() {
        // TODO: Review why running resize twice works better than once
        document.addEventListener("DOMContentLoaded", () => {
            this.resize();
        });
        
        this.eventListeners = {
            resize: () => this.resize(),
            visibility: (e) => this.lastTime = Date.now(),
            mouseenter: () => this.hover = true,
            mouseleave: () => this.hover = false
        };

        window.addEventListener('resize', this.eventListeners.resize);
        document.addEventListener('visibilitychange', this.eventListeners.visibility); // Pauses the delta time

        this.container.addEventListener('mouseenter', this.eventListeners.mouseenter);
        this.container.addEventListener('mouseleave', this.eventListeners.mouseleave);
    },

    setup() {
        this.sizeItems();

        this.container = document.createElement('div');
        this.container.style.position = 'relative';
        this.container.style.display = 'flex';
        
        this.$el.insertBefore(this.container, this.content);
        this.container.appendChild(this.content);


        this.x = this.content.offsetWidth * (this.offset / 100);
    },

    sizeItems() {
        if (this.contentCount) {
            const itemWidth = this.content.offsetWidth;
            const containerWidth = this.$el.offsetWidth;

            const requiredWidth = containerWidth / this.contentCount;
            const paddingToSet = requiredWidth - itemWidth;
            const preSetContentPadding = parseInt(this.content.style.paddingRight.split('rem')[0] * 10);

            if (paddingToSet > preSetContentPadding) {
                console.log('setpad')
                this.content.style.paddingRight = `${paddingToSet}px`;
            }
        }
    },

    resize() {
        this.repeat = Math.ceil(window.innerWidth / this.content.offsetWidth);
        
        this.container.childNodes.forEach((node) => {
            if (!node.isSameNode(this.content)) {
                node.remove();
            }
        });
        
        if (this.repeat === NaN || this.repeat === Infinity) return;

        for (let i = 0; i < this.repeat; i++) {
            const clone = this.content.cloneNode(true);

            this.content.parentNode.insertBefore(clone, this.content.nextSibling);
        }
    },

    render() {
        const time = Date.now();
        this.currentSpeed = this.hover ? Math.max(this.currentSpeed / 1.03, this.hoverSpeed) : this.speed;
        this.x += (time - this.lastTime) * (this.currentSpeed / 6000);
        this.lastTime = time;
        

        if (this.x >= this.content.offsetWidth) {
            this.x = 0;
        }

        this.container.style.transform = `translateX(-${this.x}px)`;
        
        requestAnimationFrame(() => this.render());
    }
}));